import "Layouts/default";
import "Ui/slider";
import { updateLazy } from "Functions/lazy";

document.addEventListener("DOMContentLoaded", function () {
    updateLazy();
});
